import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";

export class ReservationType1SolicitorContactModel extends ModelBase<ReservationType1SolicitorContactModel, ReservationType1SolicitorContactDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public reservationType1SolicitorId: string | undefined = undefined;

    @observable
    public industryContactAdditionalContactId: string | null = null;

    @observable
    public firstName: string | null = "";

    @observable
    public lastName: string | null = "";

    @observable
    public phoneNumber: string | null = "";

    @observable
    public email: string | null = "";

    @observable
    public isSeller: boolean = false;

    @observable
    public dateAdded: string = "";

    @observable
    public isDeleted: boolean = false;

    @observable
    public showCopyOfReservationForm: boolean | undefined = undefined;

    @observable
    public showCopyOfMemorandumofsale: boolean | undefined = undefined;
    //#endregion roperties

    @action
    public fromDto = (dto: ReservationType1SolicitorContactDTO) => {
        this.id = dto.id;
        this.reservationType1SolicitorId = dto.reservationType1SolicitorId;
        this.industryContactAdditionalContactId = dto.industryContactAdditionalContactId;
        this.firstName = dto.firstName;
        this.lastName = dto.lastName;
        this.phoneNumber = dto.phoneNumber;
        this.email = dto.email;
        this.isSeller = dto.isSeller;
        this.dateAdded = dto.dateAdded;
        this.isDeleted = dto.isDeleted;
        this.showCopyOfReservationForm = dto.showCopyOfReservationForm;
        this.showCopyOfMemorandumofsale = dto.showCopyOfMemorandumofsale;
    };

    public toDto = (): ReservationType1SolicitorContactDTO => {
        return {
            id: this.id,
            reservationType1SolicitorId: this.reservationType1SolicitorId,
            industryContactAdditionalContactId: this.industryContactAdditionalContactId,
            firstName: this.firstName,
            lastName: this.lastName,
            phoneNumber: this.phoneNumber,
            email: this.email,
            isSeller: this.isSeller,
            dateAdded: this.dateAdded,
            isDeleted: this.isDeleted,
            showCopyOfReservationForm: this.showCopyOfReservationForm,
            showCopyOfMemorandumofsale: this.showCopyOfMemorandumofsale,
        };
    };
}

export interface ReservationType1SolicitorContactDTO {
    id: string | undefined;
    reservationType1SolicitorId: string | undefined;
    industryContactAdditionalContactId: string | null;
    firstName: string | null;
    lastName: string | null;
    phoneNumber: string | null;
    email: string | null;
    isSeller: boolean;
    dateAdded: string;
    isDeleted: boolean;
    showCopyOfReservationForm?: boolean;
    showCopyOfMemorandumofsale?: boolean;
}
